import { render, staticRenderFns } from "./PriSearchesControlGroupDetailListContainer.vue?vue&type=template&id=56197f08&scoped=true"
import script from "./PriSearchesControlGroupDetailListContainer.vue?vue&type=script&lang=js"
export * from "./PriSearchesControlGroupDetailListContainer.vue?vue&type=script&lang=js"
import style0 from "./PriSearchesControlGroupDetailListContainer.vue?vue&type=style&index=0&id=56197f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56197f08",
  null
  
)

export default component.exports